import { Navigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api, RequestError } from '../lib/api.js';
import { ErrorNotice, LoadingScreen } from '../components/ui.js';

/** Old single-recipient links resolve without asking the visitor who they are. */
export function SigningEntryPage() {
  const { token } = useParams();
  const entry = useQuery({
    queryKey: ['sign-entry', token],
    queryFn: () => api.get<{ token: string }>(`/public/sign-entry/${token}`),
    retry: false,
  });

  if (entry.isLoading) return <LoadingScreen />;
  if (entry.data?.token) return <Navigate to={`/sign/${entry.data.token}`} replace />;

  return (
    <main className="max-w-xl mx-auto p-4 pt-12">
      <ErrorNotice code={entry.error instanceof RequestError ? entry.error.code : 'errors.notFound'} />
    </main>
  );
}
